module.exports = __webpack_public_path__ + "img/class2.fac8b7bb.png";